/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';

import {DiplomatObject} from '../../DiplomatObject';
import {
   DiplomatFileDescriptor,
   IDiplomatFileDescriptorWithHelpFields,
} from '../../DiplomatFileDescriptor';
import {enums} from '../../enums';
import {Schedule} from '../../Schedule';
import {EmailNotifications} from '../../EmailNotifications';
import {ArchiveDefinition} from '../../ArchiveDefinition';
import {PostTransactionCommand, PreTransactionCommand} from '../../TransactionCommand';
import {ZipParameters} from '../../ZipParameters';
import {enumType} from '../../../common/enumType';
import {Partner, SourcePartner} from '../../partners';

import {TransactionType} from '../../TransactionType';
import {yup64String} from '../../../common/yup';
import {NotificationType} from '../enums/NotificationType';
import {CONTEXT_SEND_PARAMETER} from 'common/yup/constants';
import {FileInformationNames, TransactionNames} from './transactionNames';
import {isEmpty} from 'lodash';
import {IPartner} from 'types/Partner';

export const PostTransferActions = enumType({
   NONE: 'None',
   DELETE: 'Delete',
   MOVE: 'Move',
});

// const TransactionRequest = DiplomatObject.shape({
//    "transactionType": "Inbound",
//   "transactionName": "string",
//   "overwrite": true,
//   "folderId": "string"
// })

const TransactionCore = DiplomatObject.shape({
   [TransactionNames.type]: yup.string().oneOf(TransactionType.keys),

   // ID panel
   [TransactionNames.name]: yup64String().required(),
   [TransactionNames.description]: yup.string(),

   // File Info
   [TransactionNames.fileDescriptors]: yup.array().of(DiplomatFileDescriptor),
   [TransactionNames.sourceDateFormat]: yup.string(), // Validation is outside //dateFormat(),
   [TransactionNames.sourceDateRange]: yup.string().oneOf(enums.sourceDateRange.keys),
   [TransactionNames.sourceTimeRange]: yup.string().oneOf(enums.sourceTimeRange.keys),
   [TransactionNames.failIfFilesNotFound]: yup.boolean(),
   [TransactionNames.destinationDateFormat]: yup.string(),
   [TransactionNames.destinationDateType]: yup.string().oneOf(enums.destinationDateType.keys),
   [TransactionNames.removeSourceDate]: yup.boolean(),
   [TransactionNames.removeSourceSequence]: yup.boolean(),
   [TransactionNames.overwriteType]: yup.string().oneOf(enums.overwriteType.keys),
   [TransactionNames.allowZeroLength]: yup.boolean(),
   [TransactionNames.translateInvalidChars]: yup.boolean(),
   [TransactionNames.followLinks]: yup.boolean(),
   [TransactionNames.sourceMoveSuccessPath]: yup.string(),
   [TransactionNames.sourceMoveErrorPath]: yup.string(),
   [TransactionNames.transferOrder]: yup.string().oneOf(enums.transferOrder.keys),

   // Partners
   [TransactionNames.sourcePartnerId]: yup.idString(),
   [TransactionNames.sourcePartner]: SourcePartner,
   // [TransactionNames.destinationPartnerId]: yup.idString(),
   // [TransactionNames.destinationPartner]: Partner,
   [TransactionNames.destinationPartners]: yup.array().of(Partner),
   [TransactionNames.destinationPartnerIds]: yup.array().of(yup.idString()),

   // FileHandling
   [TransactionNames.encryptDecrypt]: yup.boolean(),
   [TransactionNames.integrityProtect]: yup.boolean().default(true),
   [TransactionNames.signAuthenticate]: yup.boolean(),
   [TransactionNames.asciiArmoring]: yup.boolean(),
   [TransactionNames.pgpcomment]: yup.string().max(67),
   [TransactionNames.onePassSignature]: yup.boolean(),
   [TransactionNames.canonicalText]: yup.boolean(),
   [TransactionNames.compression]: yup.boolean(),
   [TransactionNames.sourceFtpMode]: yup.string().oneOf(enums.sourceFtpMode.keys),
   [TransactionNames.destinationFtpMode]: yup.string().oneOf(enums.destinationFtpMode.keys),
   [TransactionNames.aekIds]: yup.array().of(yup.string()).ensure(),
   [TransactionNames.deleteUnencryptedSourceFiles]: yup.boolean().default(false),

   [TransactionNames.schedule]: Schedule,

   [TransactionNames.attemptSourceDelete]: yup.boolean(),
   [TransactionNames.warnAek]: yup.boolean(),

   [TransactionNames.notifications]: EmailNotifications.defined(),
   [TransactionNames.slackWebhookUrl]: yup.url(),
   [TransactionNames.slackNotificationType]: yup.string().oneOf(NotificationType.keys),
   [TransactionNames.teamsWebhookUrl]: yup.url(),
   [TransactionNames.teamsNotificationType]: yup.string().oneOf(NotificationType.keys),

   [TransactionNames.webhookEnabled]: yup.boolean(),
   [TransactionNames.webhookUrl]: yup.url(),
   [TransactionNames.webhookNotificationType]: yup.string().oneOf(NotificationType.keys),

   [TransactionNames.archive]: ArchiveDefinition,
   [TransactionNames.troubleShooting]: yup.boolean(),
   [TransactionNames.preCommand]: PreTransactionCommand,
   [TransactionNames.postCommand]: PostTransactionCommand,
   [TransactionNames.attemptSourceMove]: yup.boolean(),
   [TransactionNames.zipParameters]: ZipParameters,
   [TransactionNames.daisyChainedCommand]: yup.object({
      continueOnFailure: yup.boolean(),
      daisyChainedID: yup.idString(),
   }),
   // aeks: yup.array().of(diplomatKeySchema),
});

const TransactionToSend = TransactionCore.clone()
   .transform(function (value, originalValue) {
      // TODO better to extract to FileInformationSchema
      // console.debug('TransactionToSend transform init ', value, originalValue, this);
      if (!value._postTransferChoice) {
         return value;
      }

      value = {
         ...originalValue,
      };
      delete value._postTransferChoice;

      switch (originalValue._postTransferChoice) {
         case PostTransferActions.enum.MOVE:
            value.attemptSourceMove = true;
            value.attemptSourceDelete = false;
            break;
         case PostTransferActions.enum.DELETE:
            value.attemptSourceMove = false;
            value.attemptSourceDelete = true;
            break;
         default:
            value.attemptSourceMove = false;
            value.attemptSourceDelete = false;
            break;
      }

      return value;
   })
   .transform(function (value, originalValue) {
      // console.debug('Transaction notify', value, origin);
      if (!value._slackNotify) {
         value.slackWebhookUrl = null;
      }
      if (!value._teamsNotify) {
         value.teamsWebhookUrl = null;
      }

      return value;
   })
   .transform(function (value, origin) {
      const encryptionKeyId = value.destinationPartners?.[0].keySet.encryptionKeyId;
      value.destinationPartners?.forEach((p: IPartner) => {
         p.keySet.encryptionKeyId = encryptionKeyId;
      });

      return value;
   })
   .transform(function (value, origin) {
      if (!value.destinationPartners?.[0].keySet.encryptionKeyId) {
         value.encryptDecrypt = false;
      }

      if (!value.sourcePartner.keySet.signatureKeyId) {
         value.signAuthenticate = false;
      }

      return value;
   });

export const TransactionWithHelpFields = TransactionCore.shape({
   _slackNotify: yup.boolean(),
   _teamsNotify: yup.boolean(),
   [FileInformationNames._postTransferChoice]: yup
      .string()
      .oneOf(PostTransferActions.keys)
      .optional(),
})
   .transform(function (value, originalValue) {
      if (value._postTransferChoice) {
         return value;
      }

      if (value.attemptSourceMove) {
         value._postTransferChoice = PostTransferActions.enum.MOVE;
      } else if (value.attemptSourceDelete) {
         value._postTransferChoice = PostTransferActions.enum.DELETE;
      } else {
         value._postTransferChoice = PostTransferActions.enum.NONE;
      }

      return value;
   })
   .transform(function (value, originalValue) {
      // console.debug('TransactionWithHelpFields notify', value, origin);
      if (value._slackNotify === undefined) {
         value._slackNotify = !!value.slackWebhookUrl;
      }
      if (value._teamsNotify === undefined) {
         value._teamsNotify = !!value.teamsWebhookUrl;
      }

      return value;
   })
   .transform(function (value, origin) {
      if (isEmpty(value.fileDescriptors)) {
         value.fileDescriptors = [DiplomatFileDescriptor.default()];
      }
      return value;
   });

export type ITransaction = yup.InferType<typeof TransactionWithHelpFields>;
type _ITransactionWithHelpFields = yup.InferType<typeof TransactionWithHelpFields>;
export interface ITransactionWithHelpFields extends _ITransactionWithHelpFields {
   [TransactionNames.fileDescriptors]: IDiplomatFileDescriptorWithHelpFields[];
}

export const Transaction = TransactionCore.when(CONTEXT_SEND_PARAMETER, {
   is: true,
   then: TransactionToSend,
   otherwise: TransactionWithHelpFields,
});
